.tabs {
  display: flex;
}
.tabs > div {
  text-align: center;
  width: 50%;
  border-bottom: 2px solid var(--static-divider-standard);
  font-weight: 500;
  padding: 8px 12px;
  color: var(--static-text-weak);
}
.tabs > div.active {
  color: var(--color-primary);
  border-bottom-color: var(--color-primary);
}
